<div>
    <!--Rounds indicator during execution-->
    <div style="text-align: -webkit-left;">
        <div *ngIf="!demo && started" style="width: 20%;">
            <p style="margin: 0;font-weight: 100;font-size: small;">{{'ROUND' | translate}}: {{round+1}}/65</p>
        </div>
    </div>

    <!--Title -->
    <h1 *ngIf="!demo" style="text-align: center; font-size: 3em;margin-top: 0px;">
        {{'MEM_T2' | translate}}
    </h1>
    <h1 *ngIf="demo" style="text-align: center; font-size: 3em;">
        {{'MEM_T1' | translate}}
    </h1>

    <!--Spinner for loading-->
    <div style="text-align: -webkit-center;text-align: -moz-center;">
        <mat-spinner *ngIf="!ready" diameter="30"></mat-spinner>
    </div>

    <div *ngIf="!started && getReady" style="font-size: 3rem; height: 20rem; display: flex; flex-direction: column; justify-content: center;">
        {{'TD_P12' | translate}}
    </div>
    <!--Instructions div-->
    <div *ngIf="!started && ready && !getReady" style="text-align: -webkit-center;text-align: -moz-center;">

        <!--Instructions text-->
        <p *ngIf="demo">{{'MEM_P3' | translate}}</p>
        <p *ngIf="!demo">{{'MEM_P4' | translate}}</p>

        <p *ngIf="task == 'alive'" style=" margin-top: 5px" [innerHTML]="'MEM_P5' | translate">
        </p>
        <p *ngIf="task == 'manmade'" style=" margin-top: 5px" [innerHTML]="'MEM_P6' | translate">
        </p>

        <p *ngIf="!demo" style=" margin-top: 5px">{{'MEM_P28' | translate}}</p>

        <p style="margin-top: 5px" [innerHTML]="'MEM_P7' | translate">
        </p>
        <p style="margin-top: 5px" [innerHTML]="'MEM_P8' | translate">
        </p>
        <button *ngIf="!started" mat-raised-button class="button" (click)="startFunction()">{{'START' | translate}}</button>

    </div>

    <!--Experiment question -->
    <div *ngIf="started" style="text-align: -webkit-center;text-align: -moz-center;">

        <!--Word-->
        <div style="margin-bottom: 2rem;  font-size: 1.5em; margin-top: 3rem;">
            <h3 *ngIf="demo"
                style="font-size: 3rem; color: white; width: min-content; padding-top: 15px; padding-bottom: 6px; padding-left: 15px; padding-right: 15px; background-color: #333333; margin-bottom: 0px;">
                {{demoData[round].word.toUpperCase()}}</h3>
            <h3 *ngIf="!demo"
                style="font-size: 3rem; color: white; width: min-content; padding-top: 15px; padding-bottom: 6px; padding-left: 15px; padding-right: 15px; background-color: #333333; margin-bottom: 0px;">
                {{liveData[round].word.toUpperCase()}}</h3>
        </div>
        
        <!--QUESTION e.g. ALIVE? or MANMADE?-->
        <h4 style="font-size: 2rem;">{{task === 'alive' ? ('MEM_ALIVE' | translate) : ('MEM_MANM' | translate)}} ?</h4>

        <!--Input instructions reminder-->
        <div style="display: flex;">
            <div style="width: 50%;text-align: left; margin-left: 5%;">
                <div style=" display: inline-block;">
                    <h4 style="font-size: 1.5rem; margin-bottom: 0px; text-align: center;">
                        {{'MEM_YES' | translate}}
                    </h4>
                    <h5 [innerHTML]="'MEM_P9' | translate" style="font-size: 1rem; margin-bottom: 5px; margin-top: 10px;">
                    </h5>
                    <div style="display: flex; justify-content: center">
                        <mat-icon>arrow_back</mat-icon>
                    </div>
                </div>
            </div>
            <div style="text-align: right; width: 50%; margin-right: 5%;">
                <div style=" display: inline-block;">
                    <h4 style="font-size: 1.5rem; margin-bottom: 0px; text-align: center;">
                        {{'MEM_NO' | translate}}
                    </h4>
                    <h5 [innerHTML]="'MEM_P10' | translate" style="font-size: 1rem; margin-bottom: 5px; margin-top: 10px;">   
                    </h5>
                    <div style="display: flex; justify-content: center">
                        <mat-icon>arrow_forward</mat-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>